import { render, staticRenderFns } from "./mDashboard.vue?vue&type=template&id=d52fe734&scoped=true&"
import script from "./mDashboard.vue?vue&type=script&lang=js&"
export * from "./mDashboard.vue?vue&type=script&lang=js&"
import style0 from "./mDashboard.vue?vue&type=style&index=0&id=d52fe734&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52fe734",
  null
  
)

export default component.exports